import React from 'react';
import classNames from 'classnames';
import { FiCheck, FiX, FiMinus, FiPlus } from 'react-icons/fi';
import { Button } from '../../components/Button';
import { getHighlightedClassName } from '../../util/getHighlightedClassName';

const Tempo = ({
   min,
   max,
   step,
   onChange,
   tempo,
   referenceTempo,
   compareAnswer,
   referencePlaying,
   highlightedControls,
}) => {
   return (
      <span
         className={classNames('tempo-control', {
            'correct-value': tempo === referenceTempo,
         })}
      >
         <Button
            type="button"
            disabled={compareAnswer || tempo - step < min}
            onClick={() => onChange(tempo - step)}
            className={classNames('button-icon', {
               [getHighlightedClassName(highlightedControls.reduceTempo)]:
                  highlightedControls.reduceTempo,
            })}
         >
            <FiMinus size="24" />
         </Button>
         <span className="tempo-value">
            <FiCheck size="24" className="correct-icon" />
            <FiX size="24" className="incorrect-icon" />
            <span>
               {compareAnswer && referencePlaying ? referenceTempo : tempo}
               <span className="tempo-bpm"> BPM</span>
            </span>
         </span>
         <Button
            type="button"
            disabled={compareAnswer || tempo + step > max}
            onClick={() => onChange(tempo + step)}
            className={classNames('button-icon', {
               [getHighlightedClassName(highlightedControls.increaseTempo)]:
                  highlightedControls.increaseTempo,
            })}
         >
            <FiPlus size="24" />
         </Button>
      </span>
   );
};

export { Tempo };
